export const STOREFRONT_CHROME_EVENT = 'wersee:storefront-chrome-change';

export type StorefrontLayout = 'classic' | 'feed';

export interface StorefrontChromeEventDetail {
  layout: StorefrontLayout;
}

const isRecord = (value: unknown): value is Record<string, unknown> => {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};

export const normalizeStorefrontThemeConfig = (value: unknown): Record<string, unknown> => {
  return isRecord(value) ? value : {};
};

export const getStorefrontLayout = (themeConfig: unknown): StorefrontLayout => {
  const config = normalizeStorefrontThemeConfig(themeConfig);
  return config.storefront_layout === 'feed' ? 'feed' : 'classic';
};

export const notifyStorefrontChrome = (layout: StorefrontLayout) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<StorefrontChromeEventDetail>(STOREFRONT_CHROME_EVENT, {
    detail: { layout },
  }));
};
